import * as yup from 'yup';

export const ForgottenPasswordValidationSchema = yup.object().shape({
	email: yup.string()
		.email('Adresse e-mail invalide')
		.required('Veuillez entrer une adresse e-mail'),
})